var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5, _rect6, _path3, _rect7, _rect8, _path4, _rect9, _rect0, _path5, _rect1, _rect10, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect11, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 150,
    viewBox: "0 0 261 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.933,
    y: 74.9804,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 120.933 74.9804)",
    fill: "#006CFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.933,
    y: 74.9804,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 120.933 74.9804)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.721 103.759L141.196 103.586L146.939 115.924L153.093 115.494L158.586 97.6224L160.075 92.6776L161.433 95.1626L164.676 93.4331L159.936 84.7881L151.162 89.3912L152.915 92.5932L155.48 91.2435L153.421 97.9304L149.827 109.672L144.967 98.5614L138.35 99.0241L138.721 103.759Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.949,
    y: 2.9873,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 76.949 2.9873)",
    fill: "#006CFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76.949,
    y: 2.9873,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 76.949 2.9873)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.233 32.0732L96.7104 31.9434L102.237 44.3801L108.398 44.0573L114.201 26.2842L115.777 21.3662L117.091 23.8745L120.364 22.2018L115.775 13.4754L106.922 17.9247L108.619 21.1568L111.208 19.8521L109.032 26.502L105.234 38.1787L100.569 26.9854L93.9447 27.3326L94.233 32.0732Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.9784,
    y: 56.9346,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 76.9784 56.9346)",
    fill: "#006CFA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.9784,
    y: 56.9346,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 76.9784 56.9346)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5894 87.9091L93.0641 88.0822L97.0344 101.1L103.188 101.53L111.115 84.5968L113.278 79.9074L114.276 82.5571L117.729 81.2958L114.238 72.0752L104.908 75.4124L106.199 78.8273L108.927 77.8478L105.957 84.183L100.764 95.3097L97.4979 83.6313L90.881 83.1686L90.5894 87.9091Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.829,
    y: 43.8725,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 163.829 43.8725)",
    fill: "#006CFA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 163.829,
    y: 43.8725,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 163.829 43.8725)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.736 71.3335L175.842 71.6294L178.459 82.9976L183.695 83.7335L191.485 69.7285L193.615 65.8482L194.31 68.1735L197.337 67.3015L194.904 59.2086L186.727 61.5043L187.626 64.5013L190.017 63.8269L187.099 69.0663L181.994 78.2698L179.899 68.0888L174.269 67.2976L173.736 71.3335Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6775,
    y: 30.8578,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 48.6775 30.8578)",
    fill: "#006CFA"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6775,
    y: 30.8578,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 48.6775 30.8578)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1047 58.4869L60.2049 58.8196L62.6226 70.2316L67.845 71.0588L75.8782 57.1919L78.0755 53.3493L78.73 55.6865L81.7724 54.8674L79.4803 46.7333L71.2647 48.8859L72.1115 51.8982L74.5143 51.2656L71.5052 56.4533L66.2396 65.5662L64.3233 55.3503L58.7078 54.4609L58.1047 58.4869Z",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 129.275,
    y: 16.9186,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 129.275 16.9186)",
    fill: "#006CFA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129.275,
    y: 16.9186,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 129.275 16.9186)",
    stroke: "#E1F2FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.606 43.8227L142.724 44.008L145.932 55.2236L151.199 55.6845L158.246 41.291L160.17 37.3045L160.985 39.5903L163.963 38.561L161.109 30.6066L153.064 33.327L154.119 36.2729L156.472 35.4743L153.832 40.8592L149.215 50.3173L146.59 40.2599L140.927 39.7644L140.606 43.8227Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 92C54 90.8954 54.8954 90 56 90H76.2654C77.2607 90 78.1046 90.7319 78.2453 91.7172L81.7547 116.283C81.8954 117.268 82.7393 118 83.7346 118H184.265C185.261 118 186.105 117.268 186.245 116.283L189.755 91.7172C189.895 90.7319 190.739 90 191.735 90H212C213.105 90 214 90.8954 214 92V118V144C214 145.105 213.105 146 212 146H182H86H56C54.8954 146 54 145.105 54 144V118V92Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 49.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 46.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 11.5,
    r: 1.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 26 150)",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206 26.5L220 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235 74L249 76",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19L41.5 26",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 83L32.5 79.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveCustom);
export default __webpack_public_path__ + "static/media/collective-custom.dce5dfc12ef298cb6ee06b0342e75da8.svg";
export { ForwardRef as ReactComponent };